import { render, staticRenderFns } from "./printBill.vue?vue&type=template&id=2fc4fb1d&scoped=true&"
import script from "./printBill.vue?vue&type=script&lang=js&"
export * from "./printBill.vue?vue&type=script&lang=js&"
import style0 from "./printBill.vue?vue&type=style&index=0&id=2fc4fb1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc4fb1d",
  null
  
)

export default component.exports